import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import "../../Styles/ProductDetail.css";
import { FiMinus, FiPlus, FiHeart, FiClock, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import {
  insertCartRequest,
  getCartRequest,
  getsimilarproductdataRequest,
  addwishlistrequest,
} from "../../Containers/Home/Home-slice";
import { connect } from "react-redux";
import { showError, showSuccess } from "../../utils/Toast";
import dhiramsymbol from "../../assests/dhirams-png.webp";
import tabbyBadge from "../../assests/tabby-badge.svg";
import { getproductbyidRequest } from "../../Containers/Home/Home-slice";
import DeliveryPromise from "../Common/DeliveryPromise";
import QuickCartDrawer from "../Common/QuickCartDrawer";
import OfferCountdown from "../Common/OfferCountdown";
import TabbyPromo from "../Payments/TabbyPromo";
import { FaBolt } from "react-icons/fa";
import axiosInstance from "../../utils/AxiosConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCcPaypal } from "@fortawesome/free-brands-svg-icons";
import {
  DEFAULT_PRODUCT_IMAGE,
  getDisplayPrice,
  getDisplayPricing,
  getProductImageList,
  isProductOutOfStock,
  withDefaultProductImage,
} from "../../utils/productPresentation";
import { formatAED } from "../../utils/currency";
import { getBuyerToken } from "../../utils/authStorage";
import { addGuestCartItem } from "../../utils/guestCart";
import {
  getJsonStorageItem,
  getViewportIsMobile,
  setStorageItem,
} from "../../utils/browser";

const WISHLIST_KEY = "wishlist_product_ids";
const HIDDEN_PRODUCT_ATTRIBUTE_KEYS = new Set([
  "source_brand",
  "source_category",
  "source_sub_category",
  "import_source",
  "excel_row_number",
  "category_code",
  "sub_category_code",
  "cost_aed",
  "actual_price",
  "selling_price",
  "elumia_margin_aed",
  "elumia_margin_pct",
  "competitor_price_aed",
  "competitor_margin_aed",
  "competitor_margin_pct",
  "master_code",
  "item_code",
  "item_name",
]);
const PRODUCT_ATTRIBUTE_LABELS = {
  unit: "Unit",
  pack_qty: "Pack Qty",
  size_dosage: "Size / Dosage",
};

const normalizeAttributeKey = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

const parseProductAttributes = (attributes) => {
  if (!attributes) return {};
  if (typeof attributes === "object" && !Array.isArray(attributes)) return attributes;
  if (typeof attributes !== "string") return {};

  try {
    const parsed = JSON.parse(attributes);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch (error) {
    return {};
  }
};

const parseOfferNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const normalizeActiveOffer = (value) => {
  if (!value || typeof value !== "object") {
    return null;
  }

  const offerId = Number.parseInt(value?.offer_id ?? value?.offerId, 10);
  const originalPrice = parseOfferNumber(
    value?.original_price ?? value?.originalPrice,
  );
  const offerPrice = parseOfferNumber(value?.offer_price ?? value?.offerPrice);

  if (!Number.isInteger(offerId) || offerId <= 0 || originalPrice <= 0 || offerPrice <= 0) {
    return null;
  }

  const parsedRemainingSeconds = Number(
    value?.remaining_seconds ?? value?.remainingSeconds,
  );

  return {
    offer_id: offerId,
    original_price: originalPrice,
    offer_price: offerPrice,
    offer_discount_amount: parseOfferNumber(
      value?.offer_discount_amount ??
        value?.offerDiscountAmount ??
        value?.discount_amount ??
        value?.discountAmount ??
        Math.max(originalPrice - offerPrice, 0),
    ),
    offer_title: String(value?.offer_title ?? value?.offerTitle ?? "").trim(),
    offer_message: String(
      value?.offer_message ?? value?.offerMessage ?? "",
    ).trim(),
    from_date: value?.from_date ?? value?.fromDate ?? null,
    to_date:
      value?.to_date ??
      value?.toDate ??
      value?.offer_end_at ??
      value?.offerEndAt ??
      value?.end_date ??
      value?.endDate ??
      value?.offer_end_time ??
      value?.offerEndTime ??
      value?.ends_at ??
      value?.endsAt ??
      null,
    remaining_seconds: Number.isFinite(parsedRemainingSeconds)
      ? parsedRemainingSeconds
      : null,
  };
};

const formatAttributeLabel = (key = "") => {
  const normalizedKey = normalizeAttributeKey(key);
  if (PRODUCT_ATTRIBUTE_LABELS[normalizedKey]) {
    return PRODUCT_ATTRIBUTE_LABELS[normalizedKey];
  }

  return String(key || "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

const paymentMethods = [
    { label: "Visa", image: "https://d28wu8o6itv89t.cloudfront.net/images/Visadebitcardpng-1599584312349.png", color: "white", type: "image" },
    {
      label: "Mastercard",
      image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/MasterCard_Logo.svg/1280px-MasterCard_Logo.svg.png",
      color: "white",
      type: "image",
    },
    { label: "PayPal", image: "https://www.shutterstock.com/image-illustration/paypal-logo-on-transparent-background-260nw-2311643717.jpg", color: "white", type: "image" },
    {
      label: "Tabby",
      image: tabbyBadge,
      type: "image",
    },
    {
      label: "Tamara",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRMPgJSHwiQvqev0zA95g6dEjuyrqRyDphAw&s",
      type: "image",
    },
  ];

function ProductDetail({
  addcartdata,
  insertCartRequest,
  getCartRequest,
  getsimilarproductdataRequest,
  similarproductdata,
  addwishlistdata,
  addwishlistrequest,
  getproductbyidRequest,
  getproductbyiddata,
  getproductbyidLoading,
}) {
  const getWishlistFromStorage = () => {
    return getJsonStorageItem(WISHLIST_KEY, []);
  };
  const saveWishlistToStorage = (ids) => {
    setStorageItem(WISHLIST_KEY, JSON.stringify(ids));
  };

  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state?.item || location.state?.product;

  const catname = location.state?.catname || null;
  const [isZooming, setIsZooming] = useState(false);
  const [zoomPos, setZoomPos] = useState({ x: 50, y: 50 });

  const [qty, setQty] = useState(1);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [bannerOpen, setBannerOpen] = useState(false);
  const [sellerDetails, setSellerDetails] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [productCoupons, setProductCoupons] = useState([]);
  const [isCouponsLoading, setIsCouponsLoading] = useState(false);
  const [quickDrawerOpen, setQuickDrawerOpen] = useState(false);
  const [quickDrawerProduct, setQuickDrawerProduct] = useState(null);
  const [offerExpired, setOfferExpired] = useState(false);

  // Store current product in state so we can update it when similar product is clicked
  const [currentProduct, setCurrentProduct] = useState(null);
  const [localWishlistIds, setLocalWishlistIds] = useState([]);
  const [requestedProductId, setRequestedProductId] = useState(null);

  // Track if user manually selected a thumbnail
  const [userSelectedThumbnail, setUserSelectedThumbnail] = useState(false);
  const [mainImage, setMainImage] = useState("");
  const mobileTouchStartX = useRef(null);

  // Ref for scrolling similar products
  const similarProductsRef = useRef(null);

  // Check screen size for mobile
  useEffect(() => {
    setIsMobile(getViewportIsMobile());
    setLocalWishlistIds(getWishlistFromStorage());

    const handleResize = () => {
      setIsMobile(getViewportIsMobile());
    };
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fallback = {
    id: id || "",
    name: "Product unavailable",
    priceNumber: 0,
    price: "",
    tagText: "",
    imageUrl: DEFAULT_PRODUCT_IMAGE,
    thumbnails: [DEFAULT_PRODUCT_IMAGE],
    description: "This product is no longer available.",
    stock_quantity: 0,
    attributes: {},
    discount: 0,
  };

  const handleProductImageError = (event) => {
    event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
  };

  // Create a safe product object that won't cause read-only errors
  const getSafeProduct = (product) => {
    if (!product) return fallback;

    const parsedImages = getProductImageList(product);
    const primaryImage = parsedImages[0] || product.singleImage || product.imageUrl || product.image || DEFAULT_PRODUCT_IMAGE;
    const safeImages = parsedImages.length
      ? parsedImages.map((image) => withDefaultProductImage(image))
      : [withDefaultProductImage(primaryImage)];

    // Create a new object to avoid modifying read-only props
    return {
      ...product,
      id: product.id,
      name: product.name || product.title,
      category_id: product.category_id ?? product.categoryid ?? null,
      sub_category_id: product.sub_category_id ?? product.subcategoryid ?? null,
      priceNumber:
        typeof getDisplayPrice(product) === "number"
          ? getDisplayPrice(product)
          : fallback.priceNumber,
      price: getDisplayPrice(product),
      tagText: product.tagText,
      imageUrl: withDefaultProductImage(primaryImage),
      image_url: withDefaultProductImage(primaryImage),
      image_urls: safeImages,
      allImages: safeImages,
      thumbnails: safeImages,
      description: product.description || fallback.description,
      stock_quantity:
        product.stock_quantity !== undefined
          ? product.stock_quantity
          : fallback.stock_quantity,
      attributes: product.attributes || fallback.attributes,
      discount: product.discount || fallback.discount,
      is_wishlisted: product.is_wishlisted || fallback.is_wishlisted,
      singleImage: withDefaultProductImage(primaryImage),
    };
  };

  const normalizedRouteId = Number(id) || null;
  const hasFetchedProduct = Array.isArray(getproductbyiddata);
  const fetchedProduct =
    hasFetchedProduct && normalizedRouteId
      ? getproductbyiddata.find(
          (product) => Number(product?.id || product?.product_id) === normalizedRouteId,
        ) || null
      : hasFetchedProduct && getproductbyiddata.length === 1
        ? getproductbyiddata[0]
        : null;
  const currentProductMatchesRoute =
    normalizedRouteId && Number(currentProduct?.id || currentProduct?.product_id) === normalizedRouteId;
  const itemMatchesRoute =
    normalizedRouteId && Number(item?.id || item?.product_id) === normalizedRouteId;
  const hasRequestedCurrentProduct = requestedProductId === normalizedRouteId;
  const shouldHideProduct =
    hasRequestedCurrentProduct &&
    !getproductbyidLoading &&
    hasFetchedProduct &&
    !fetchedProduct;
  const productSource = shouldHideProduct
    ? null
    : fetchedProduct ||
      (currentProductMatchesRoute ? currentProduct : null) ||
      (itemMatchesRoute ? item : null);
  const p = productSource ? getSafeProduct(productSource) : null;
  const rawActiveOffer = useMemo(
    () => normalizeActiveOffer(p?.active_offer) || normalizeActiveOffer(p),
    [p],
  );
  const visibleAttributes = useMemo(() => {
    const parsedAttributes = parseProductAttributes(p?.attributes);

    return Object.entries(parsedAttributes)
      .filter(([key, value]) => {
        const normalizedKey = normalizeAttributeKey(key);
        if (HIDDEN_PRODUCT_ATTRIBUTE_KEYS.has(normalizedKey)) return false;
        if (value === null || value === undefined) return false;

        const normalizedValue = Array.isArray(value)
          ? value
              .map((entry) => String(entry || "").trim())
              .filter(Boolean)
          : String(value).trim();

        return Array.isArray(normalizedValue)
          ? normalizedValue.length > 0
          : normalizedValue !== "";
      })
      .map(([key, value]) => ({
        key,
        label: formatAttributeLabel(key),
        values: Array.isArray(value)
          ? value.map((entry) => String(entry).trim()).filter(Boolean)
          : String(value)
              .split(",")
              .map((entry) => entry.trim())
              .filter(Boolean),
      }))
      .filter((attribute) => attribute.values.length > 0);
  }, [p?.attributes]);
  const hasRenderableProduct = Boolean(p);
  const productImageUrl = p?.imageUrl || "";
  const breadcrumbCategoryLabel = catname || p?.category_name || "Products";
  const productMetaRows = [
    { label: "Brand", value: p?.brand_name },
    { label: "Category", value: p?.category_name || catname },
    { label: "Sub-category", value: p?.sub_category_name },
    { label: "Size / Dosage", value: p?.size_dosage },
    { label: "Unit", value: p?.unit },
  ].filter((row) => row.value);
  const isOutOfStock = isProductOutOfStock(p);

  const thumbnails = useMemo(() => {
    if (!p) return [];

    const orderedImages = getProductImageList(p).map((image) =>
      withDefaultProductImage(image),
    );

    if (orderedImages.length > 0) {
      return orderedImages;
    }

    return [withDefaultProductImage(p.singleImage || p.imageUrl || p.image_url)];
  }, [p]);

  // ALL useEffect hooks MUST come before any conditional returns or complex logic
  useEffect(() => {
    const getSellerDetails = async () => {
      if (!id) return;

      try {
        const response = await axiosInstance.get(`getSellerByProductId/${id}`);
        setSellerDetails(response?.data?.data);
      } catch (error) {
        console.error("Seller lookup error:", error);
      }
    };

    getSellerDetails();
  }, [id]);

  useEffect(() => {
    if (id) {
      getsimilarproductdataRequest(id);
    }
  }, [id, getsimilarproductdataRequest]);

  useEffect(() => {
    if (id) {
      setRequestedProductId(Number(id) || null);
      getproductbyidRequest(id);
    }
  }, [id, getproductbyidRequest]);

  useEffect(() => {
    let isMounted = true;

    const fetchProductCoupons = async () => {
      if (!id) {
        if (isMounted) {
          setProductCoupons([]);
          setIsCouponsLoading(false);
        }
        return;
      }

      if (isMounted) {
        setIsCouponsLoading(true);
      }

      try {
        const response = await axiosInstance.get(`products/${id}/coupons`);
        const coupons = Array.isArray(response?.data?.data) ? response.data.data : [];

        if (isMounted) {
          setProductCoupons(coupons);
        }
      } catch {
        if (isMounted) {
          setProductCoupons([]);
        }
      } finally {
        if (isMounted) {
          setIsCouponsLoading(false);
        }
      }
    };

    fetchProductCoupons();

    return () => {
      isMounted = false;
    };
  }, [id]);

  useEffect(() => {
    if (Array.isArray(getproductbyiddata)) {
      setCurrentProduct(getproductbyiddata[0] || null);
    }
  }, [getproductbyiddata]);

  useEffect(() => {
    if (!addwishlistdata) return;
    if (addwishlistdata.success) {
      showSuccess("Wish list updated successfully");
    }
  }, [addwishlistdata]);

  useEffect(() => {
    if (addwishlistdata && addwishlistdata.success === false) {
      const rollback = getWishlistFromStorage();
      setLocalWishlistIds(rollback);
    }
  }, [addwishlistdata]);

  useEffect(() => {
    if (!addcartdata) return;
    if (addcartdata.success) {
      showSuccess(addcartdata.message);
      getCartRequest();
    }
  }, [addcartdata, getCartRequest]);

  // Initialize current product from location state or item
  useEffect(() => {
    if (item) {
      setCurrentProduct(item);
    }
  }, [item]);

  // Update main image when product changes, but only if user hasn't manually selected a thumbnail
  useEffect(() => {
    if (!hasRenderableProduct) return;

    if (!userSelectedThumbnail) {
      if (productImageUrl) {
        setMainImage(productImageUrl);
      } else if (thumbnails.length > 0) {
        setMainImage(thumbnails[0]);
      } else {
        setMainImage(DEFAULT_PRODUCT_IMAGE);
      }
    }
  }, [hasRenderableProduct, productImageUrl, thumbnails, userSelectedThumbnail]);

  // Reset userSelectedThumbnail when product ID changes
  useEffect(() => {
    setUserSelectedThumbnail(false);
  }, [id]);

  useEffect(() => {
    setOfferExpired(false);
  }, [p?.id, rawActiveOffer?.offer_id, rawActiveOffer?.to_date, rawActiveOffer?.remaining_seconds]);

  // Now all hooks are done, we can proceed with the rest of the logic

  const handleImageMouseMove = (e) => {
    if (isMobile) return; // Disable zoom on mobile
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setZoomPos({ x, y });
  };

  const activeOffer = offerExpired ? null : rawActiveOffer;
  const activeOfferEndTime =
    activeOffer?.to_date ||
    activeOffer?.end_date ||
    activeOffer?.offer_end_at ||
    activeOffer?.ends_at ||
    null;
  const effectivePricingProduct =
    activeOffer && p
      ? {
          ...p,
          ...activeOffer,
        }
      : offerExpired && p
        ? {
            ...p,
            offer_id: null,
            original_price: null,
            offer_price: null,
            offer_discount_amount: null,
          }
        : p;
  const productPricing = getDisplayPricing(effectivePricingProduct);
  const hasLimitedTimeOffer = Boolean(activeOffer && productPricing.hasOffer);
  const productDiscountPct = productPricing.discountPercent;
  const originalUnit = productPricing.originalPrice;
  const discountedUnit = Math.round(productPricing.finalPrice);
  const mobileUnitPrice = new Intl.NumberFormat("en-AE", { maximumFractionDigits: 2 }).format(productPricing.finalPrice);

  const bulkPct = 4;
  const bulkOnDiscountedUnit = Math.round(discountedUnit * (1 - bulkPct / 100));

  const showUnitPrice =
    selectedOffer === "bulk" ? bulkOnDiscountedUnit : discountedUnit;

  const unitPriceUsedForSubtotal =
    selectedOffer === "bulk" && qty >= 5
      ? bulkOnDiscountedUnit
      : discountedUnit;

  const subtotal = unitPriceUsedForSubtotal * qty;

  const savedPerUnit = Math.max(0, originalUnit - unitPriceUsedForSubtotal);
  const totalSaved = savedPerUnit * qty;

  function numberWithCommas(x) {
    if (x == null || Number.isNaN(Number(x))) return "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function formatCouponDate(value) {
    if (!value) return null;

    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  const renderOfferHighlight = () => {
    if (!hasLimitedTimeOffer || !activeOffer || !activeOfferEndTime) {
      return null;
    }

    return (
      <div className="pd-offer-highlight">
        <div className="pd-offer-highlight__countdown">
          <FiClock />
          <OfferCountdown
            endTime={activeOfferEndTime}
            fallbackText="Limited time offer"
            expiredText="Offer expired"
            showZeroDays
            onExpire={() => {
              setOfferExpired(true);
              if (id) {
                getproductbyidRequest(id);
              }
            }}
          />
        </div>
      </div>
    );
  };

  const renderPriceBlock = ({ mobile = false } = {}) => {
    if (hasLimitedTimeOffer) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "6px",
            marginBottom: mobile ? "12px" : "14px",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              borderRadius: "999px",
              background: "#fef3c7",
              color: "#92400e",
              fontSize: mobile ? "11px" : "12px",
              fontWeight: "700",
              letterSpacing: "0.02em",
              padding: "6px 10px",
            }}
          >
            Limited Time Offer
          </span>
          <span
            style={{
              fontSize: mobile ? "24px" : "28px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            {formatAED(productPricing.finalPrice)}
          </span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <span
              style={{
                textDecoration: "line-through",
                color: "#6b7280",
                fontSize: mobile ? "14px" : "15px",
              }}
            >
              {formatAED(productPricing.originalPrice)}
            </span>
            <span
              style={{
                fontSize: mobile ? "13px" : "14px",
                fontWeight: "700",
                color: "#059669",
              }}
            >
              Save {formatAED(productPricing.discountAmount)}
            </span>
          </div>
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: "12px",
          marginBottom: mobile ? "12px" : "14px",
        }}
      >
        <span
          style={{
            fontSize: mobile ? "24px" : "28px",
            fontWeight: "700",
            color: "#111827",
            display: "flex",
            gap: "3%",
          }}
        >
          <img
            src={dhiramsymbol}
            width={mobile ? 24 : 30}
            height={mobile ? 24 : 30}
            alt="dhiram symbol"
            style={mobile ? undefined : { alignSelf: "center" }}
          />
          <span>{mobile ? mobileUnitPrice : numberWithCommas(discountedUnit)}</span>
        </span>
        {(productPricing.hasOffer || productDiscountPct > 0) && (
          <>
            <span
              style={{
                textDecoration: "line-through",
                color: "#6b7280",
                fontSize: mobile ? "14px" : "15px",
              }}
            >
              {numberWithCommas(originalUnit)}
            </span>
            <span
              style={{
                fontSize: mobile ? "13px" : "14px",
                fontWeight: "700",
                color: "#059669",
              }}
            >
              {productPricing.hasOffer
                ? `Save AED ${numberWithCommas(productPricing.discountAmount)}`
                : `${parseInt(productDiscountPct, 10)}% OFF`}
            </span>
          </>
        )}
      </div>
    );
  };

  const renderCouponSection = () => (
    <div style={{ marginTop: "20px" }}>
      <b>Coupons</b>
      {isCouponsLoading ? (
        <div style={{ marginTop: "8px", color: "#6b7280", fontSize: "14px" }}>
          Checking active coupons...
        </div>
      ) : productCoupons.length > 0 ? (
        <div style={{ display: "flex", gap: "10px", marginTop: "8px", flexWrap: "wrap" }}>
          {productCoupons.map((coupon) => {
            const couponMeta = [];
            const minimumOrderAmount = Number(coupon?.min_order_amount || 0);
            const formattedExpiry = formatCouponDate(coupon?.valid_until);

            if (minimumOrderAmount > 0) {
              couponMeta.push(`Min. order AED ${numberWithCommas(minimumOrderAmount)}`);
            }

            if (formattedExpiry) {
              couponMeta.push(`Valid until ${formattedExpiry}`);
            }

            return (
              <div key={coupon.id} style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <div className="pd-offer-tag">{coupon.display_text || coupon.title || coupon.code}</div>
                <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: 1.5, maxWidth: "220px" }}>
                  {coupon.code ? (
                    <div style={{ color: "#111827", fontWeight: "600" }}>Code: {coupon.code}</div>
                  ) : null}
                  {coupon.description ? <div>{coupon.description}</div> : null}
                  {couponMeta.length > 0 ? <div>{couponMeta.join(" | ")}</div> : null}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ marginTop: "8px", color: "#6b7280", fontSize: "14px" }}>
          No active coupons available.
        </div>
      )}
    </div>
  );

  const [openId, setOpenId] = useState(null);
  const [brochureDropdownOpen, setBrochureDropdownOpen] = useState(false);

  if (!p) {
    const isLoadingProduct = !hasRequestedCurrentProduct || getproductbyidLoading;

    return (
      <div
        className="pdscoped_001 pd-root"
        role="region"
        aria-label="Product detail"
        style={{ backgroundColor: "white", minHeight: "50vh", display: "grid", placeItems: "center" }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "520px",
            border: "1px solid #e5e7eb",
            borderRadius: "16px",
            padding: "32px 24px",
            textAlign: "center",
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <img
            src={DEFAULT_PRODUCT_IMAGE}
            alt="Product placeholder"
            style={{ width: "120px", height: "120px", objectFit: "contain", marginBottom: "16px" }}
          />
          <h1 style={{ marginBottom: "10px", fontSize: "24px", fontWeight: "600" }}>
            {isLoadingProduct ? "Loading product..." : "Product unavailable"}
          </h1>
          <p style={{ margin: "0 0 18px", color: "#6b7280", lineHeight: 1.6 }}>
            {isLoadingProduct
              ? "Please wait while we load the product details."
              : "This product is pending approval, rejected, inactive, or no longer available for customer viewing."}
          </p>
          <button
            type="button"
            onClick={() => navigate("/")}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "12px 20px",
              background: "#3b4cca",
              color: "#fff",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  function toggleItem(id) {
    setBrochureDropdownOpen(false);
    setOpenId((prev) => (prev === id ? null : id));
  }

  function toggleBrochureDropdown(e) {
    e.stopPropagation();
    setBrochureDropdownOpen((prev) => !prev);
    setOpenId("brochure");
  }

  const openQuickCartDrawer = (product) => {
    setQuickDrawerProduct({
      ...product,
      title: product?.title || product?.name,
      name: product?.name || product?.title,
      imageUrl:
        product?.imageUrl ||
        product?.image_url ||
        product?.singleImage ||
        product?.image,
      quantity: product?.quantity ? Number(product.quantity) : 1,
    });
    setQuickDrawerOpen(true);
  };

  const onclickcart = (data) => {
    if (isProductOutOfStock(data)) {
      showError("This product is currently out of stock.");
      return;
    }

    const payload = {
      product_id: data?.id ?? data?.product_id,
      quantity: isMobile ? qty : data?.quantity ? Number(data.quantity) : 1,
      price: Number(getDisplayPrice(data) ?? 0),
      discount: Number(data?.discount ?? 0),
      attributes: data.attributes,
    };
    const offerForCart =
      normalizeActiveOffer(data?.active_offer) || normalizeActiveOffer(data);
    if (offerForCart?.offer_id) {
      payload.offer_id = offerForCart.offer_id;
    }

    if (!payload.product_id) {
      return;
    }

    if (!getBuyerToken()) {
      addGuestCartItem(payload);
      showSuccess("Cart Added Successfully");
      openQuickCartDrawer(data);
      return;
    }

    insertCartRequest(payload);
    openQuickCartDrawer(data);
  };

  const onclickcartTwo = (data) => {
    if (isProductOutOfStock(data)) {
      showError("This product is currently out of stock.");
      return;
    }

    const payload = {
      product_id: data?.id ?? data?.product_id,
      quantity: data?.quantity ? Number(data.quantity) : 1,
      price: Number(getDisplayPrice(data) ?? 0),
      discount: Number(data?.discount ?? 0),
      attributes: data.attributes,
    };
    const offerForCart =
      normalizeActiveOffer(data?.active_offer) || normalizeActiveOffer(data);
    if (offerForCart?.offer_id) {
      payload.offer_id = offerForCart.offer_id;
    }

    if (!payload.product_id) {
      return;
    }

    if (!getBuyerToken()) {
      addGuestCartItem(payload);
      showSuccess("Cart Added Successfully");
      openQuickCartDrawer(data);
      return;
    }

    insertCartRequest(payload);
    openQuickCartDrawer(data);
  };

  // Function to handle clicking on a similar product
  const handleSimilarProductClick = (product) => {
    setCurrentProduct(product);
    setUserSelectedThumbnail(false);
    navigate(`/product/${product.id}`, {
      state: {
        item: product,
        catname: catname,
      },
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Function to handle thumbnail click
  const handleThumbnailClick = (image) => {
    setMainImage(image);
    setUserSelectedThumbnail(true);
  };

  const stepMobileImage = (direction) => {
    if (thumbnails.length < 2) return;
    const index = Math.max(0, thumbnails.indexOf(mainImage));
    handleThumbnailClick(thumbnails[(index + direction + thumbnails.length) % thumbnails.length]);
  };

  const cleanNumber = (value) => {
    if (!value) return 0;
    return parseFloat(value.toString().replace(/,/g, ""));
  };

  const SimpleProductCard = ({ product, onClick }) => {
    const imageUrl = product.singleImage || product.image_url;
    const pricingDetails = getDisplayPricing(product);
    const price = pricingDetails.originalPrice;
    const discount = cleanNumber(product.discount);
    const oldPrice = pricingDetails.hasOffer || discount > 0 ? price : null;
    const currentPrice = pricingDetails.finalPrice;
    const formatPrice = (value) => numberWithCommas(Number(value).toFixed(2));
    const similarOutOfStock = isProductOutOfStock(product);

    return (
      <div
        className="ds-product-card ds-product-card-hover"
        onClick={() => onClick(product)}
      >
        <div className="ds-product-card-media">
          {pricingDetails.hasOffer ? (
            <div className="ds-product-card-badge">
              Save AED {formatPrice(pricingDetails.discountAmount)}
            </div>
          ) : discount > 0 ? (
            <div className="ds-product-card-badge">{discount}% OFF</div>
          ) : null}
          <img
            src={withDefaultProductImage(imageUrl)}
            alt={product.name}
            onError={handleProductImageError}
          />
        </div>

        <p className="ds-product-card-name">{product.name}</p>

        <div className="ds-product-card-prices">
          <span
            style={{ display: "flex", gap: "3%" }}
            className="ds-product-card-price"
          >
            <img
              style={{ alignSelf: "center" }}
              alt="diram symbol"
              src={dhiramsymbol}
              width={20}
              height={20}
            />
            <span>{formatPrice(currentPrice)}</span>
          </span>
          {oldPrice && (
            <span className="ds-product-card-old-price">
              {numberWithCommas(oldPrice)}
            </span>
          )}
        </div>

        <button
          type="button"
          className="ds-product-card-btn"
          disabled={similarOutOfStock}
          style={
            similarOutOfStock
              ? { opacity: 0.7, cursor: "not-allowed" }
              : undefined
          }
          onClick={(e) => {
            e.stopPropagation();
            onclickcartTwo(product);
          }}
        >
          {similarOutOfStock ? "Out of Stock" : "Add to Cart"}
        </button>
      </div>
    );
  };

  function AccordionItem({ item, isOpen, onToggle }) {
    const contentRef = useRef(null);
    const [maxH, setMaxH] = useState("0px");

    useEffect(() => {
      if (contentRef.current) {
        if (isOpen) {
          const h = contentRef.current.scrollHeight;
          setMaxH(h + 24 + "px");
        } else {
          setMaxH("0px");
        }
      }
    }, [isOpen, brochureDropdownOpen]);

    return (
      <div className={`pd-acc-item ${item.id === "faqs" ? "small" : ""}`}>
        <button
          className={`acc-title ${isOpen ? "open" : ""}`}
          onClick={() => onToggle(item.id)}
          aria-expanded={isOpen}
        >
          <span className="acc-title-text">{item.title}</span>

          {item.isBrochure ? (
            <div
              className="brochure-actions"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="download-btn"
                onClick={toggleBrochureDropdown}
                aria-haspopup="true"
                aria-expanded={brochureDropdownOpen}
              >
                Download{" "}
                <span className={`chev ${brochureDropdownOpen ? "rot" : ""}`}>
                  ▾
                </span>
              </button>
            </div>
          ) : (
            <span className={`chev ${isOpen ? "rot" : ""}`} aria-hidden>
              ▾
            </span>
          )}
        </button>

        <div
          className={`acc-body ${isOpen ? "expanded" : ""}`}
          style={{ maxHeight: isOpen ? maxH : "0px" }}
        >
          <div className="acc-body-inner" ref={contentRef}>
            {item.isBrochure ? (
              <>
                {brochureDropdownOpen ? (
                  <ul className="brochure-list">
                    {item.body.map((file, idx) => (
                      <li key={idx}>
                        <a href={file.url} className="brochure-link">
                          {file.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="brochure-hint">
                    Click "Download" to view available brochures.
                  </div>
                )}
              </>
            ) : (
              <div className="acc-sub">{item.body}</div>
            )}
          </div>
        </div>

        <div className="divider" />
      </div>
    );
  }

  const isWishlisted =
    localWishlistIds.includes(p?.id) || Number(p?.is_wishlisted) === 1;

  const onclickaddwishlist = (data) => {
    const productId = data.id;
    let updatedWishlist = [...localWishlistIds];

    if (updatedWishlist.includes(productId)) {
      updatedWishlist = updatedWishlist.filter((id) => id !== productId);
    } else {
      updatedWishlist.push(productId);
    }

    setLocalWishlistIds(updatedWishlist);
    saveWishlistToStorage(updatedWishlist);
    addwishlistrequest(productId);
  };

  // Helper function to get processed thumbnails
  const getProcessedThumbnails = () => {
    const baseUrl = "https://neeuro-ai.s3.ap-south-1.amazonaws.com/";
    let thumbnailsData = p.thumbnails || p.image_urls || [];

    if (thumbnailsData && thumbnailsData.length > 0) {
      if (
        typeof thumbnailsData[0] === "string" &&
        thumbnailsData[0].startsWith("[")
      ) {
        try {
          const parsedArray = JSON.parse(thumbnailsData[0]);
          return parsedArray.map((filename) => {
            const cleanFilename = filename.replace(/['"]/g, "");
            return cleanFilename.includes(baseUrl)
              ? cleanFilename
              : `${baseUrl}${cleanFilename}`;
          });
        } catch (error) {
          console.error("Failed to parse thumbnails JSON:", error);
        }
      }

      return thumbnailsData.map((item) => {
        if (item.includes(baseUrl)) {
          return item;
        } else {
          const cleanItem = item.replace(/['"]/g, "");
          return `${baseUrl}${cleanItem}`;
        }
      });
    }

    const mainImg = p.imageUrl || p.image_url || fallback.imageUrl;
    return [mainImg.includes(baseUrl) ? mainImg : `${baseUrl}${mainImg}`];
  };

  const firstLetter = sellerDetails?.username
    ? sellerDetails.username.charAt(0).toUpperCase()
    : "?";

  const profileImage = sellerDetails?.profile_image;

  // Mobile-specific layout
  if (isMobile) {
    return (
      <>
        <style>
          {`
            .pdscoped_001 .pd-root {
              padding: 12px;
            }
            .pd-breadcrumbs {
              margin-bottom: 12px;
              font-size: 12px;
              flex-wrap: wrap;
            }
            .mobile-product-layout {
              display: flex;
              flex-direction: column;
              gap: 16px;
            }
            .mobile-image-section {
              width: 100%;
            }
            .mobile-thumbnails {
              display: flex;
              gap: 8px;
              margin-top: 12px;
              overflow-x: auto;
              padding-bottom: 8px;
            }
            .mobile-thumbnail {
              flex-shrink: 0;
              width: 50px;
              height: 50px;
              border-radius: 6px;
              cursor: pointer;
            }
            .mobile-main-image {
              width: 100%;
              height: 300px;
              border: 1px solid #eee;
              border-radius: 8px;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #fff;
            }
            .mobile-main-image img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }
            .mobile-info-section {
              width: 100%;
            }
            .mobile-seller-card {
              border: 1px solid #e5e7eb;
              border-radius: 12px;
              background: #fff;
              margin-top: 16px;
              padding: 16px;
            }
            .mobile-accordion {
              margin-top: 16px;
            }
            .similar-products {
              margin-top: 24px;
              padding: 0 12px;
            }
            .delivery-badge {
              margin: 12px 0;
            }
          `}
        </style>

        <div className="pdscoped_001 pd-root" role="region" aria-label="Product detail">
          <div className="pd-breadcrumbs">
            <button className="pd-breadcrumb-back" onClick={() => navigate("/")}>
              Home
            </button>
            <span className="pd-breadcrumb-sep">›</span>
            <span className="pd-breadcrumb-crumb" onClick={() => navigate(`/viewall/${p?.category_id || ""}`)}>
              {breadcrumbCategoryLabel}
            </span>
            {catname && <span className="pd-breadcrumb-sep">›</span>}
            <span className="pd-breadcrumb-current">{p?.name}</span>
          </div>

          <h1 className="mobile-product-title pd-title">{p?.name}</h1>

          <div className="mobile-product-layout">
            {/* Image Section */}
            <div className="mobile-image-section">
              <div className="mobile-main-image" onTouchStart={(event) => { mobileTouchStartX.current = event.touches[0]?.clientX; }} onTouchEnd={(event) => {
                if (mobileTouchStartX.current === null) return;
                const distance = event.changedTouches[0]?.clientX - mobileTouchStartX.current;
                if (Math.abs(distance) > 45) stepMobileImage(distance < 0 ? 1 : -1);
                mobileTouchStartX.current = null;
              }}>
                <img
                  src={withDefaultProductImage(mainImage || p.imageUrl || fallback.imageUrl)}
                  alt={p.name}
                  onError={handleProductImageError}
                />
                {thumbnails.length > 1 && <>
                  <button type="button" className="mobile-image-arrow is-prev" aria-label="Previous product image" onClick={() => stepMobileImage(-1)}><FiChevronLeft /></button>
                  <button type="button" className="mobile-image-arrow is-next" aria-label="Next product image" onClick={() => stepMobileImage(1)}><FiChevronRight /></button>
                </>}
              </div>
              {thumbnails.length > 0 && (
                <div className="mobile-thumbnails">
                  {thumbnails.map((img, i) => (
                    <button
                      type="button"
                      key={i}
                      aria-label={`View product image ${i + 1}`}
                      aria-pressed={mainImage === img || (!mainImage && i === 0)}
                      onClick={() => handleThumbnailClick(img)}
                      className="mobile-thumbnail"
                    ><img src={withDefaultProductImage(img)} alt="" onError={handleProductImageError} /></button>
                  ))}
                </div>
              )}
            </div>

            {/* Info Section */}
            <div className="mobile-info-section">
              {isOutOfStock ? (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "6px 10px",
                    borderRadius: "999px",
                    background: "#fee2e2",
                    color: "#b91c1c",
                    fontSize: "12px",
                    fontWeight: "700",
                    marginBottom: "10px",
                  }}
                >
                  Out of Stock
                </div>
              ) : null}
              
              {renderPriceBlock({ mobile: true })}
              <TabbyPromo price={productPricing.finalPrice} source="product" />

              {renderOfferHighlight()}

              {productMetaRows.length > 0 && (
                <div
                  style={{
                    display: "grid",
                    gap: "8px",
                    marginBottom: "12px",
                    padding: "12px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    background: "#f8fafc",
                  }}
                >
                  {productMetaRows.map((row) => (
                    <div
                      key={row.label}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "12px",
                        fontSize: "13px",
                      }}
                    >
                      <span style={{ color: "#6b7280" }}>{row.label}</span>
                      <span style={{ fontWeight: "600", textAlign: "right" }}>{row.value}</span>
                    </div>
                  ))}
                </div>
              )}

              {/* <div className="delivery-badge">
                <div className="delivery-promise is-placeholder">
                  <span className="delivery-promise__icon" aria-hidden="true">
                    <FaBolt />
                  </span>
                  <span className="delivery-promise__content">
                    <span className="delivery-promise__label">Get it in 4 hour</span>
                  </span>
                </div>
              </div> */}

              <DeliveryPromise product={p} />
              <div className="mobile-quantity-control" role="group" aria-label="Quantity">
                <span>Quantity</span>
                <button type="button" aria-label="Decrease quantity" disabled={qty <= 1} onClick={() => setQty((current) => Math.max(1, current - 1))}><FiMinus /></button>
                <output aria-live="polite">{qty}</output>
                <button type="button" aria-label="Increase quantity" disabled={isOutOfStock || qty >= Number(p?.stock_quantity || 99)} onClick={() => setQty((current) => current + 1)}><FiPlus /></button>
              </div>

              {/* Add to Cart Button - Mobile */}
              <button
                className="mobile-product-add"
                style={{
                  width: "100%",
                  background: isOutOfStock ? "var(--color-text-light)" : "#3b4cca",
                  color: "var(--color-surface)",
                  padding: "14px",
                  border: "none",
                  borderRadius: "4px",
                  fontWeight: "700",
                  cursor: isOutOfStock ? "not-allowed" : "pointer",
                  opacity: isOutOfStock ? 0.8 : 1,
                  marginTop: "12px"
                }}
                disabled={isOutOfStock}
                onClick={() => onclickcart(p)}
              >
                {isOutOfStock ? "OUT OF STOCK" : "ADD TO CART"}
              </button>
              {isOutOfStock ? (
                <div style={{ marginTop: "10px", color: "#b91c1c", fontSize: "13px", fontWeight: "600" }}>
                  Currently unavailable
                </div>
              ) : null}

              {/* Seller Card */}
              <div className="mobile-seller-card">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div style={{
                    width: "40px",
                    height: "40px",
                    background: "#ffe100",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    overflow: "hidden"
                  }}>
                    {profileImage ? (
                      <img src={profileImage} alt="profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    ) : (
                      firstLetter
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "14px" }}>Sold by {sellerDetails?.username} ›</div>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div style={{ marginTop: "20px" }}>
                <b>Description</b>
                <p style={{ marginTop: "8px", color: "#555", fontSize: "14px" }}>
                  {p.description || "Product description not available"}
                </p>
              </div>

              {/* Coupons */}
              {renderCouponSection()}

              {/* Payment Methods */}
              <div style={{ marginTop: "20px" }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>Accepted Payments</div>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {paymentMethods.map((method) => (
                    <div key={method.label} style={{
                      width: "50px",
                      height: "38px",
                      background: "#fff",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px"
                    }}>
                      {method.label === "PayPal" ? <FontAwesomeIcon icon={faCcPaypal} title="PayPal" style={{ fontSize: "28px", color: "var(--color-primary)" }} /> : <img src={method.image} alt={method.label} style={{ maxWidth: "40px", maxHeight: "28px", objectFit: "contain" }} />}
                    </div>
                  ))}
                </div>
              </div>

              {/* Attributes */}
              <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                {visibleAttributes.length > 0 ? (
                  visibleAttributes.map((attribute) => {
                    return (
                      <div key={attribute.key} style={{ marginBottom: "15px" }}>
                        <b>{attribute.label}</b>
                        <div style={{ marginTop: "8px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                          {attribute.values.map((item, index) => (
                            <button key={index} className="model">{item.trim()}</button>
                          ))}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>No attributes available</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Similar Products */}
        <div className="similar-products">
          <h3 className="sp-title">Continue Browsing</h3>
          <div className="sp-wrapper">
            <div className="sp-scroll-container" ref={similarProductsRef}>
              <div className="sp-products-row">
                {similarproductdata && similarproductdata.length > 0
                  ? similarproductdata.map((product) => (
                      <SimpleProductCard
                        key={product.id}
                        product={product}
                        onClick={handleSimilarProductClick}
                      />
                    ))
                  : null}
              </div>
            </div>
          </div>
        </div>
        <QuickCartDrawer
          isOpen={quickDrawerOpen}
          onClose={() => setQuickDrawerOpen(false)}
          product={quickDrawerProduct}
          imageUrl={
            quickDrawerProduct?.imageUrl || quickDrawerProduct?.image_url
          }
        />
      </>
    );
  }

  // Desktop Layout (Original)
  return (
    <>
      <style>
        {`
          .scrollable-content {
            -ms-overflow-style: none;
            scrollbar-width: none;
            overflow-y: auto;
          }
          .scrollable-content::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>

      <div className="pdscoped_001 pd-root" role="region" aria-label="Product detail" style={{ backgroundColor: "white" }}>
        <div style={{ marginTop: "3%" }} className="pd-breadcrumbs">
          <button className="pd-breadcrumb-back" style={{ color: "var(--deep-navy)" }} onClick={() => navigate("/")}>
            Home
          </button>
          <span className="pd-breadcrumb-sep" style={{ color: "var(--deep-navy)", cursor: "pointer" }}>›</span>
          <span className="pd-breadcrumb-crumb" style={{ color: "var(--deep-navy)", cursor: "pointer" }} onClick={() => navigate(`/viewall/${p?.category_id || ""}`)}>
            {breadcrumbCategoryLabel}
          </span>
          <span className="pd-breadcrumb-sep" style={{ color: "var(--deep-navy)" }}>{catname && "›"}</span>
          <span className="pd-breadcrumb-current" style={{ color: "var(--deep-navy)" }}>{p?.name}</span>
        </div>

        <div style={{ display: "flex", gap: "24px", alignItems: "flex-start", marginTop: "3%", position: "relative" }}>
          {/* LEFT SIDE - FIXED (STICKY) */}
          <div style={{ position: "sticky", top: "20px", width: "auto", flexShrink: 0 }}>
            <div style={{ display: "flex", gap: "16px" }}>
              {/* Thumbnails */}
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {(thumbnails.length ? thumbnails : fallback.thumbnails).map((img, i) => (
                  <img
                    key={i}
                    src={withDefaultProductImage(img)}
                    alt={`${p.name} thumbnail ${i + 1}`}
                    onError={handleProductImageError}
                    onClick={() => handleThumbnailClick(img)}
                    style={{
                      width: "60px",
                      height: "60px",
                      border: mainImage === img ? "2px solid #2874f0" : "1px solid #ddd",
                      borderRadius: "6px",
                      cursor: "pointer",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </div>

              {/* MAIN IMAGE WITH ZOOM */}
              <div
                style={{
                  width: "420px",
                  height: "420px",
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  overflow: "hidden",
                  position: "relative",
                  cursor: "zoom-in",
                  background: "#fff",
                }}
                onMouseEnter={() => !isMobile && setIsZooming(true)}
                onMouseLeave={() => !isMobile && setIsZooming(false)}
                onMouseMove={!isMobile ? handleImageMouseMove : undefined}
              >
                <img
                  src={withDefaultProductImage(mainImage || p.imageUrl || fallback.imageUrl)}
                  onError={handleProductImageError}
                  alt={p.name}
                  draggable={false}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transform: !isMobile && isZooming ? "scale(2)" : "scale(1)",
                    transformOrigin: `${zoomPos.x}% ${zoomPos.y}%`,
                    transition: isZooming ? "none" : "transform 0.3s ease",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE - SCROLLABLE CONTAINER */}
          <div className="scrollable-content" style={{ flex: 1, maxHeight: "calc(100vh - 120px)", display: "flex", gap: "24px" }}>
            {/* MIDDLE CONTENT */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <h1 style={{ fontSize: "22px", fontWeight: "600" }}>{p?.name}</h1>
              {isOutOfStock ? (
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "6px 10px",
                    borderRadius: "999px",
                    background: "#fee2e2",
                    color: "#b91c1c",
                    fontSize: "12px",
                    fontWeight: "700",
                    marginTop: "8px",
                  }}
                >
                  Out of Stock
                </div>
              ) : null}

              <div style={{ margin: "8px 0", color: "#388e3c" }}>★★★★☆ 4.5 (18782 Ratings)</div>

              {renderPriceBlock()}
              <TabbyPromo price={productPricing.finalPrice} source="product" />

              {renderOfferHighlight()}

              {productMetaRows.length > 0 && (
                <div
                  style={{
                    display: "grid",
                    gap: "10px",
                    // marginBottom: "16px",
                    padding: "14px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    background: "#f8fafc",
                  }}
                >
                  {productMetaRows.map((row) => (
                    <div
                      key={row.label}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "16px",
                        fontSize: "14px",
                      }}
                    >
                      <span style={{ color: "#6b7280" }}>{row.label}</span>
                      <span style={{ fontWeight: "600", textAlign: "right" }}>{row.value}</span>
                    </div>
                  ))}
                </div>
              )}
              
              {/* <div className="delivery-badge">
                <div className="delivery-promise is-placeholder">
                  <span className="delivery-promise__icon" aria-hidden="true">
                    <FaBolt />
                  </span>
                  <span className="delivery-promise__content">
                    <span className="delivery-promise__label">Get it in 4 hour</span>
                  </span>
                </div>
              </div> */}

              {/* Description */}
              <div style={{ marginTop: "20px" }}>
                <b>Description</b>
                <p style={{ marginTop: "8px", color: "#555" }}>{p.description || "Product description not available"}</p>
              </div>

              {/* Coupons */}
              {renderCouponSection()}
              
              <div style={{ marginTop: "12px" }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>Accepted Payments</div>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {paymentMethods.map((method) => (
                    <div key={method.label} style={{ width: "60px", height: "44px", background: "#fff", border: "1px solid #e5e7eb", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", padding: "4px" }}>
                      <img src={method.image} alt={method.label} style={{ maxWidth: "46px", maxHeight: "30px", objectFit: "contain" }} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Model */}
              {/* <div style={{ marginTop: "20px" }}>
                <b>Model</b>
                <div style={{ marginTop: "8px" }}>
                  <button className="model active"> {p?.name}</button>
                </div>
              </div> */}

              {/* Storage */}
              <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                {visibleAttributes.length > 0 ? (
                  visibleAttributes.map((attribute) => {
                    return (
                      <div key={attribute.key} style={{ marginBottom: "15px" }}>
                        <b>{attribute.label}</b>
                        <div style={{ marginTop: "8px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                          {attribute.values.map((item, index) => (
                            <button key={index} className="model">{item.trim()}</button>
                          ))}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>No attributes available</div>
                )}
              </div>
            </div>

            {/* RIGHT SELLER BOX */}
            <div style={{ width: "30%", minWidth: "280px", flexShrink: 0 }}>
              <div style={{ border: "1px solid #e5e7eb", borderRadius: "12px", background: "#fff", overflow: "hidden" }}>
                <div style={{ padding: "16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div style={{ width: "40px", height: "40px", background: "#ffe100", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "700", overflow: "hidden" }}>
                      {profileImage ? (
                        <img src={profileImage} alt="profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      ) : (
                        firstLetter
                      )}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "14px" }}>Sold by {sellerDetails?.username} ›</div>
                      <div style={{ fontSize: "14px", marginTop: "4px" }}>
                        <span style={{ color: "#16a34a", fontWeight: "600" }}>★ 4.8</span>
                        <span style={{ marginLeft: "8px", color: "#6b7280" }}>87% Positive</span>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: "14px", display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{ background: "#f3f4f6", padding: "8px 10px", borderRadius: "6px", display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                      <span>Item as shown</span>
                      <span style={{ color: "#16a34a", fontWeight: "600" }}>90%</span>
                    </div>
                    <div style={{ background: "#f3f4f6", padding: "8px 10px", borderRadius: "6px", display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                      <span>Partner since</span>
                      <span style={{ color: "#16a34a", fontWeight: "600" }}>8+ Y</span>
                    </div>
                    <div style={{ background: "#f3f4f6", padding: "8px 10px", borderRadius: "6px", fontSize: "14px" }}>
                      Great recent rating
                    </div>
                  </div>

                  <button style={{ marginTop: "14px", width: "100%", border: "1px solid #d1d5db", padding: "10px", borderRadius: "8px", background: "#fff", cursor: "pointer", fontWeight: "500" }}>
                    More offers from other sellers ›
                  </button>
                </div>

                <div style={{ borderTop: "1px solid #e5e7eb" }} />

                <div style={{ padding: "16px", fontSize: "14px" }}>
                  <div style={{ marginBottom: "10px" }}>✔ 1 year warranty</div>
                  <div style={{ marginBottom: "10px" }}>✔ Easy and Hassle Free Returns</div>
                  <div>✔ Secure Payments</div>
                </div>

                <div style={{ padding: "16px" }}>
                  <button
                    style={{
                      width: "100%",
                      background: isOutOfStock ? "#94a3b8" : "#3b4cca",
                      color: "#fff",
                      padding: "14px",
                      border: "none",
                      borderRadius: "12px",
                      fontWeight: "700",
                      cursor: isOutOfStock ? "not-allowed" : "pointer",
                      opacity: isOutOfStock ? 0.8 : 1,
                    }}
                    disabled={isOutOfStock}
                    onClick={() => onclickcart(p)}
                  >
                    {isOutOfStock ? "OUT OF STOCK" : "ADD TO CART"}
                  </button>
                  {isOutOfStock ? (
                    <div style={{ marginTop: "10px", color: "#b91c1c", fontSize: "13px", fontWeight: "600" }}>
                      Currently unavailable
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="similar-products">
        <h3 className="sp-title">Continue Browsing</h3>
        <div className="sp-wrapper">
          <div className="sp-scroll-container" ref={similarProductsRef}>
            <div className="sp-products-row">
              {similarproductdata && similarproductdata.length > 0
                ? similarproductdata.map((product) => (
                    <SimpleProductCard
                      key={product.id}
                      product={product}
                      onClick={handleSimilarProductClick}
                    />
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
      <QuickCartDrawer
        isOpen={quickDrawerOpen}
        onClose={() => setQuickDrawerOpen(false)}
        product={quickDrawerProduct}
        imageUrl={quickDrawerProduct?.imageUrl || quickDrawerProduct?.image_url}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    addcartdata: state.Home.Cartdata,
    similarproductdata: state.Home.getsimilarproductdata?.data,
    addwishlistdata: state.Home.addwishlistdata,
    getproductbyiddata: state.Home.getproductbyiddata?.data,
    getproductbyidLoading: state.Home.getproductbyidLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    insertCartRequest: (data) => dispatch(insertCartRequest(data)),
    getCartRequest: () => dispatch(getCartRequest()),
    getsimilarproductdataRequest: (data) =>
      dispatch(getsimilarproductdataRequest(data)),
    addwishlistrequest: (data) => dispatch(addwishlistrequest(data)),
    getproductbyidRequest: (data) => dispatch(getproductbyidRequest(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
